import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';

const Banner: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Banner');
    const isEu = ['eu', 'de', 'fr', 'uk', 'es', 'it', 'nl'].includes(locale)
    const isUk = ['uk'].includes(locale)

    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: isEu ? (isUk ? 'https://websiteoss.ecoflow.com/upload/image/1774321855924/uk.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1774321855723/eu.jpg') : 'https://websiteoss.ecoflow.com/upload/image/1761633366514/top%20center.jpg',
        pad: isEu ? (isUk ? 'https://websiteoss.ecoflow.com/upload/image/1773891897469/m-uk-kv.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1773891897113/m-kv.jpg') : 'https://websiteoss.ecoflow.com/upload/image/1761633928408/topcenter_h5.jpg',
        h5: isEu ? (isUk ? 'https://websiteoss.ecoflow.com/upload/image/1773891897469/m-uk-kv.jpg' : 'https://websiteoss.ecoflow.com/upload/image/1773891897113/m-kv.jpg') : 'https://websiteoss.ecoflow.com/upload/image/1761633928408/topcenter_h5.jpg',
        label: t('label'),
        title: t('title'),
        desc: t('desc'),
        theme: 'white',

        // 按钮
        lType: 'outlined',
        lChildren: isEu ? '' : <>{t('btn')}</>,
        // lHref: locale === 'us' ? 'https://us.ecoflow.com/products/trail-series' : 'https://ca.ecoflow.com/products/trail-series',
        lHref: isEu ? '' : 'https://youtube.com/embed/MpWhT9Dv7HQ?si=xtIN9iUK1f-QXkqA',
        lBtnIsYouToBe: isEu ? false : true,
        lDataLayer: {
            event: 'uaEvent',
            event_name: 'buy',
            product_name: t('title'),
            position: 'Product Detail_1',
            __btn_id1: `${styles.Banner} .eco-banner-card-btn-youtube`,
            __btn_id2: 'https://youtube.com/embed/MpWhT9Dv7HQ?si=xtIN9iUK1f-QXkqA',
            __btn_type: 'href',
        },
    };
    return (
        <div className={`${styles.Banner} GtmModuleData-section`} data-section-id="d3c-Banner">
            <EcoBanner theme="white" {...dataA} />
            <div className="footer-desc eco-content">{t('footer_desc')}</div>
        </div>
    );
};

export default Banner;
